import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FileUpload } from './file-upload.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [FileUpload],
})
export class FileUploadModule {}
